// in TailwindCSS, 16px = 1rem
const convertPxToRem = (pxNumber: number): number => {
    return pxNumber / 16;
}

export const NumberUtil = {
    convertPxToRem,
}
